import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col select-none bg-gray-50 overflow-auto" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-5 text-sm text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-medium text-secondary" }, "Indberetninger")
], -1)
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "grow px-6 py-5" }
const _hoisted_7 = { class: "text-xl font-medium text-secondary" }
const _hoisted_8 = { class: "text-sm font-medium text-blue-900" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 px-6" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "9",
    height: "40",
    viewBox: "0 0 9 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M8.02899 20.4773L2.56306 25.9432C2.29944 26.2068 1.87206 26.2068 1.60847 25.9432L0.97096 25.3057C0.707794 25.0425 0.707288 24.616 0.969835 24.3522L5.30168 20L0.969835 15.6478C0.707288 15.384 0.707794 14.9575 0.97096 14.6943L1.60847 14.0568C1.87208 13.7932 2.29947 13.7932 2.56306 14.0568L8.02896 19.5227C8.29257 19.7863 8.29257 20.2137 8.02899 20.4773Z",
      fill: "#E5E7EB"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_adjust_height = _resolveDirective("adjust-height")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardItems, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.goto(item.path)),
              class: "flex items-center bg-white text-sm text-gray-400 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1)
              ]),
              _hoisted_9
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ])), [
    [_directive_adjust_height]
  ])
}